/** Soft direction field f_i = (x[a_i] - x_i) / (ε + ||…||) */

export function softDirection(
  positions: Float64Array,
  targets: Int32Array,
  dim: number,
  softening: number,
  out: Float64Array,
): void {
  const n = targets.length;
  for (let i = 0; i < n; i++) {
    const ti = targets[i]! * dim;
    const oi = i * dim;
    let distSq = 0;
    for (let d = 0; d < dim; d++) {
      const delta = positions[ti + d]! - positions[oi + d]!;
      out[oi + d] = delta;
      distSq += delta * delta;
    }
    const inv = 1 / (softening + Math.sqrt(distSq));
    for (let d = 0; d < dim; d++) {
      out[oi + d]! *= inv;
    }
  }
}
